import { Injectable } from "@angular/core";
import { BaseApiService } from "../shared/_base.api.service";

import { PagedApiResponse } from "../../utils/types/shared/_paged-api-response.type";
import { Observable } from "rxjs";
import { map } from "rxjs";
import { App } from "../../utils/types/admon/app.type";
import { AppMapper } from "../../utils/mappers/admon/app.mapper";
import { FilterType } from "../../utils/types/shared/_filter.type";
import { APP_ENDPOINTS } from "../../components/mediaManager/admon/company/company-endpoints";

@Injectable()
export class AppService extends BaseApiService<App> {
    model = App;
    mapper = new AppMapper();
    apiEndPoint: any = APP_ENDPOINTS;

    getList(
        filter: FilterType,
        companyId?: number
    ): Observable<PagedApiResponse<App>> {
        return this.http
            .get(
                this.apiEndPoint.list.replace(
                    "{companyId}",
                    companyId.toString()
                )
            )
            .pipe(
                map((res) => {
                    return this.sharedMapper.mapPagedApiResponse(
                        res,
                        this.mapper.mapList,
                        this.model
                    );
                })
            );
    }

    create(data: App): Observable<boolean> {
        const endpoint = this.apiEndPoint.base.replace(
            "{companyId}",
            data.companyId.toString()
        );
        return this.http.post<boolean>(endpoint, data).pipe(
            map((res) => {
                return res;
            })
        );
    }

    update(data: App): Observable<boolean> {
        const { companyId, id, name, redirectUri } = data;
        const endpoint = this.apiEndPoint.item
            .replace("{companyId}", companyId.toString())
            .replace("{id}", id.toString());
        return this.http.put<boolean>(endpoint, { name, redirectUri });
    }

    activationToggle(id: number, data?: App): Observable<boolean> {
        const { companyId, isActive: status } = data;
        const endpoint = this.apiEndPoint.activation
            .replace("{companyId}", companyId.toString())
            .replace("{id}", id.toString());
        return this.http.put<boolean>(endpoint, { status });
    }

    delete(id: number, companyId?: number): Observable<boolean> {
        const endpoint = this.apiEndPoint.item
            .replace("{companyId}", companyId.toString())
            .replace("{id}", id.toString());
        return this.http.delete<boolean>(endpoint);
    }
}
